import { useTranslation } from "react-i18next";
import { FaCircleCheck } from "react-icons/fa6";
import { HStack } from "../../../../styled-system/jsx";
import type { PhaseStatus } from "../types";

const styles: Record<PhaseStatus, { bg: string; fg: string }> = {
  done: { bg: "green.600/15", fg: "green.700" },
  running: { bg: "bootstrapBlue/15", fg: "bootstrapBlue" },
  queued: { bg: "expanderBackground", fg: "text.secondary" },
  failed: { bg: "error/15", fg: "error" },
};

export const StatusBadge = ({ status }: { status: PhaseStatus }) => {
  const { t } = useTranslation(["onboarding"]);

  const label: Record<PhaseStatus, string> = {
    done: t(($) => $.onboarding["Done"]),
    running: t(($) => $.onboarding["Running"]),
    queued: t(($) => $.onboarding["Queued"]),
    failed: t(($) => $.onboarding["Failed"]),
  };

  return (
    <HStack
      as="span"
      gap="xsmall"
      css={{
        display: "inline-flex",
        alignItems: "center",
        paddingX: "10px",
        paddingY: "3px",
        borderRadius: "pill",
        fontSize: "small",
        fontWeight: "bold",
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        backgroundColor: styles[status].bg,
        color: styles[status].fg,
      }}
    >
      {status === "done" && <FaCircleCheck size={12} />}
      {label[status]}
    </HStack>
  );
};
